import React, { ReactNode, RefObject } from 'react';
import { Translate } from 'react-redux-i18n';
import logo from '../../../img/home/structure.svg';
import Button from '../../common/Button';
import FindStructureModal from './components/FindStructureModal';
import { EntityDTO } from '../../../network/api/types/compte/EntityDTO';
import StructureSelected from './components/StructureSelected';
import { getStructureNameV2 } from '../../../services/utils';

type Props = {
  divRef: RefObject<HTMLDivElement>;
  update: (values) => void;
  onChange: (index: number) => void;
  initialSelectedStructure: EntityDTO[],
};

type State = {
  isModalOpen: boolean,
  selectedStructure: EntityDTO[],
};

class CreationStructurePro extends React.Component<Props, State> {
  state: State = {
    isModalOpen: false,
    selectedStructure: this.props.initialSelectedStructure,
  };

  openModal = ():void => {
    this.setState((previousState) => ({ isModalOpen: !previousState.isModalOpen }));
  };

  saveStructure = (entity: EntityDTO):void => {
    this.openModal();
    this.setState((previousState) => ({
      selectedStructure: [...previousState.selectedStructure, entity],
    }));
    this.props.onChange(2);
  };

  deleteStrucutre = (index: number): void => {
    const array = [...this.state.selectedStructure];
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ selectedStructure: array });
    }
    this.props.onChange(2);
  };

  render(): ReactNode {
    return (
      <div ref={this.props.divRef} className="account-activation-form-container">
        <div className="account-activation-col">
          <h3>
            <Translate value="CREATION.STRUCTURE_PRO" />
          </h3>
        </div>
        <div className="account-activation-col add-structure-form">
          <Translate value="CREATION.RATTACHEMENT_INFO" />
          {this.state.selectedStructure.length > 0
                    && (
                    <div className="selected-structures">
                      {this.state.selectedStructure.map((entity, index) => (
                        <StructureSelected
                          key={entity.ou}
                          structureName={getStructureNameV2(entity)}
                          structureGeographicAddress={entity.residence}
                          structurePCcode={entity.departementResidence?.libelle}
                          onClick={() => this.deleteStrucutre(index)}
                        />
                      ))}
                    </div>
                    )}
          {this.state.selectedStructure.length > 0
            ? (
              <Button
                type="third"
                onClick={() => this.openModal()}
                i18nKey="CREATION.FIND_OTHER_STRUCTURE"
              />
            )
            : (
              <Button
                type="primary"
                onClick={() => this.openModal()}
                i18nKey="CREATION.FIND_STRUCTURE"
              />
            )}
          {this.state.selectedStructure.length > 0
                && (
                <div className="button-container">
                  <Button
                    type="primary"
                    onClick={() => this.props.update({ entities: this.state.selectedStructure })}
                    i18nKey="actions.NEXT"
                  />
                </div>
                )}
        </div>
        <div className="account-activation-col">
          <div>
            <img className="logo" src={logo} alt="logo" />
          </div>
          <Translate value="CREATION.RATTACHEMENT" />
        </div>
        <FindStructureModal
          isModalOpen={this.state.isModalOpen}
          openModal={this.openModal}
          saveStructure={(entity: EntityDTO) => this.saveStructure(entity)}
          selectedStructure={this.state.selectedStructure}
        />
      </div>
    );
  }
}

export default CreationStructurePro;
